import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Button } from '@shopify/polaris'

import * as shopifyAppSceneId from 'constants/shopifyAppSceneId'
import CreateNewScene from './shopifyIAEditorLayer/CreateNewScene'
import { getTemplateInfo } from 'templates/templates'
// import { addSlide } from 'controllers/logic'

const Container = styled.div`
  text-align: center;
  position: absolute;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 12;
  background-color: gold;
`
const ButtonContainer = styled.div`
  margin-top: 3rem;
  margin-right: 3rem;
  font-size: 2.6rem;
  text-align: right;
  & > button {
    z-index: 501
  }
`

class ShopifyIAEditorLayer extends Component {

  createNewScene = () => {
    const { app, startProductsSlideWizard } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (app.slidesCnt < templateInfo.maxSlides) {
      // dispatch(addSlide(app))
      startProductsSlideWizard()
    }
  }

  onIAButtonClick = () => {
    const { field, onIAButtonClick } = this.props
    onIAButtonClick(field.iaButton)
  }

  render () {
    const { field } = this.props
    if (field.id === shopifyAppSceneId.PRODUCTS_SCENES_DASHBOARD_EMPTY) {
      return (
        <Container>
          <CreateNewScene onClick={this.createNewScene} />
        </Container>
      )
    } else if (field.iaButton) {
      return (
        <ButtonContainer>
          <Button size='slim' onClick={this.onIAButtonClick}>{field.iaButton.title}</Button>
        </ButtonContainer>
      )
    } else {
      return null
    }
  }

}

ShopifyIAEditorLayer.propTypes = {
  app: PropTypes.object.isRequired,
  field: PropTypes.object.isRequired,
  startProductsSlideWizard: PropTypes.func.isRequired,
  onIAButtonClick: PropTypes.func
}


export default connect()(ShopifyIAEditorLayer)



// WEBPACK FOOTER //
// ./src/components/shopifyApp/shopifyWizard/ShopifyIAEditorLayer.js